import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import IconBellRing from '@adv-mt/mt-svg-icons/lib/BellRing.js'
import IconBinOutline from '@adv-mt/mt-svg-icons/lib/BinOutline.js'
import IconEditRounded from '@adv-mt/mt-svg-icons/lib/EditRounded.js'
import IconPeriodForwardOutline from '@adv-mt/mt-svg-icons/lib/PeriodForwardOutline.js'

import CardAlertItem from '../item/index.js'

const baseClass = 'mt-CardAlertMenu'

const noop = () => {}

const CardAlertMenu = ({
  allowFiltersUpdate,
  frequencyNotification,
  onClickChangeFrequency = noop,
  onClickCTAButton = noop,
  onClickDelete = noop,
  onClickUpdateFilters = noop
}) => {
  const {i18n, domain} = useContext(Context)
  const config = domain.get('config')
  const isMobile = config.get('isMobile')

  return (
    <>
      {isMobile && <span className={`${baseClass}-line`}></span>}
      <div className={`${baseClass}-menu`}>
        <CardAlertItem icon={IconBellRing} onItemClick={onClickCTAButton} text={i18n.t('SEARCH_SAVE_SHOW_RESULTS')} />
        {allowFiltersUpdate && (
          <CardAlertItem
            icon={IconEditRounded}
            onItemClick={onClickUpdateFilters}
            text={i18n.t('SEARCH_SAVE_UPDATE')}
          />
        )}
        {frequencyNotification ? (
          <CardAlertItem
            icon={IconPeriodForwardOutline}
            onItemClick={onClickChangeFrequency}
            text={i18n.t('SEARCH_SAVE_FREQUENCY_SELECTION.TITLE')}
          />
        ) : null}
        <CardAlertItem icon={IconBinOutline} onItemClick={onClickDelete} text={i18n.t('SEARCH_SAVE_DELETE')} />
      </div>
    </>
  )
}

CardAlertMenu.displayName = 'CardAlertMenu'

CardAlertMenu.propTypes = {
  allowFiltersUpdate: PropTypes.bool.isRequired,
  frequencyNotification: PropTypes.string,
  onClickChangeFrequency: PropTypes.func,
  onClickCTAButton: PropTypes.func,
  onClickDelete: PropTypes.func,
  onClickUpdateFilters: PropTypes.func
}

export default CardAlertMenu
